{
	"people": "People",
	"tooltipCrop": "Crop (R)",
	"tooltipEdit": "Edit (E)",
	"tooltipMasking": "Masking (W)",
	"tooltipRemove": "Remove (Q)"
}
